<template>
    <el-drawer
        title="手动填写绑定抖音的信息"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
        append-to-body
    >
        <div class="drawer-content" v-loading="dataLoading">
			<div class="color-warning MB20">				 
				<p>修改下面的内容，不会修改场地本身的信息，只是用于场地绑定不上抖音的时候，手动修改匹配内容。<br> 如果某个字段没有填写，系统自动读取场地本身信息</p>				
			</div>
            <el-form
                :model="formData"                
                ref="formData"
                label-position="top"
            >
                
                <el-form-item prop="poiId" label="抖音POI ID:">
                    <el-input v-model="formData.poiId" placeholder="请输入抖音POI ID" size="medium" maxlength="40"></el-input>
                </el-form-item>
				<el-form-item prop="name" label="名称">
				    <el-input v-model="formData.name" placeholder="请输入名称" size="medium" maxlength="40"></el-input>
				</el-form-item>				
				<el-form-item prop="cityCode" label="所在城市:">
				    <el-cascader
				        v-model="formData.cityCode"
				        :options="cityList"
				        filterable
				        :props="{label:'name',children:'cityList',value:'code',emitPath:false}"
				        size="medium"
				        style="width:100%">
				    </el-cascader>
				</el-form-item>
				<el-form-item prop="address" label="详细地址">
				    <el-input v-model="formData.address" placeholder="请输入详细地址" size="medium" maxlength="40"></el-input>
				</el-form-item>
				<el-form-item prop="longitude" label="经度">
				    <el-input v-model="formData.longitude" placeholder="请输入经度" size="medium" maxlength="40"></el-input>
					<small class="color-danger"><span class="el-icon-warning"></span> 经度必须为 -180 到 180 之间的数值, 而且小数点必须保留 6 位小数, 比如 121.504899</small>
				</el-form-item>
				<el-form-item prop="latitude" label="纬度">
				    <el-input v-model="formData.latitude" placeholder="请输入纬度" size="medium" maxlength="40"></el-input>
					<small class="color-danger"><span class="el-icon-warning"></span> 经度必须为 -90 到 90 之间的数值, 而且小数点必须保留 6 位小数, 比如 31.231705</small>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'

const defaultFormData = {
    poiId:'',
    name:"",
    cityCode:'',	
	latitude:'',
	longitude:'',
	address:'',
	
}
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
    },
    components:{},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData:{...defaultFormData},
            cityList:[],//所有省份城市集合      
            id:'',
            
        }
    },
    created(){
        
    },
	mounted(){
		this.getCityList();
	},
    methods:{
        
       //获取所有城市
       async getCityList(){
           const res = await fetchAllCity({}).catch(() => {});
           const{ state, result} = res.data;
           if( state == 1 ){
               this.cityList = result;
           }
       },
        close() {
            this.formData = {...defaultFormData};
			this.drawerShow = false;
            this.$refs['formData'].clearValidate();
           
        },
        show() {
            this.id = this.userId;			
            if(this.id){
                this.getData();
            }
            this.drawerShow = true;
        },

        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/site/douyinInfo',
                params: {id: this.userId},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,                           
                        }
                   
					  this.formData.cityCode = result.cityCode ? parseInt(result.cityCode) : 10;
					  
                    } else {
                        this.formData = {
                            ...defaultFormData                                                
                        }
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });   
        },
       
        // 表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submitAction()                    
                } else {
                    return false;
                }
            });
        },
        submitAction(){
			if( this.formData.longitude == '' && this.formData.latitude != ''){
				this.$message.error("经度不能为空");
				return
			}
			if( this.formData.longitude !== '' && this.formData.latitude == ''){
				this.$message.error("纬度不能为空");
				return
			}
			const _reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{6}|180)$/;						
			if (!_reg.test(this.formData.longitude) && this.formData.longitude != '') {
			   this.$message.error("经度格式有误，请重新输入");
			   return
			}
			const _reg2 = /^(\-|\+)?([0-8]?\d{1}\.\d{6}|90\.0{6}|[0-8]?\d{1}|90)$/;
			if (!_reg2.test(this.formData.latitude) && this.formData.latitude != '') {
			   this.$message.error("纬度格式有误，请重新输入");
			   return
			}
			const _url = "/site/saveDouyinInfo";
            this.btnLoading = true;
            this.$request({
                url: _url,
                data: {
                    ...this.formData, 
					userId:this.userId				  
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success("操作成功");
                        this.close();
						this.$emit('onUpdate');
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-box{
    text-align: center;
    .el-image{
        max-width: 100%;
    }
}
.upload-btn {
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    position: relative;
    background: $--color-theme;
    overflow: hidden;
    .upload-bar{
        ::v-deep .el-upload{
            width: 100%;
        }
    }
    .el-button {
        width: 100%;
        background: none;
        border: 0;
    }
    .progress-bar {
        display: block;
        height: 100%;
        color: #ffffff;
        span {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
        }
        .progress {
            height: 100%;
            background: #67c23a;
            transition: width 0.6s ease-out;
        }
    }
}
</style>